import { BasePrice, ChargeAttachType } from 'modules/equipment/types';

import { QuoteChargeListingEntity, QuoteLineItemType } from '../types';
import { QuoteCalcPriceInput, QuoteCalcRowInput } from '../api/types';

class QuoteCalcMapper {
  public toPreviewRows(rows: QuoteChargeListingEntity[] = []): QuoteCalcRowInput[] {
    return rows.map(row => {
      if (row.type === QuoteLineItemType.Equipment && row.equipment) {
        return {
          type: 'EQUIPMENT',
          equipment: {
            equipmentId: row.equipment.equipmentId,
            price: this.toCalcPrice(row.equipment.price),
            attachments: (row.equipment.attachments ?? []).map(attachment => ({
              price: this.toCalcPrice(attachment.price),
            })),
          },
        };
      }

      const charge = row.charge;

      return {
        type: 'INVOICE',
        charge: charge
          ? {
              id: charge.id ?? null,
              parentId: charge.parentId ?? null,
              parentType: charge.parentType ?? null,
              type: charge.type,
              label: charge.label ?? null,
              amount: charge.amount ?? null,
              amountType: charge.amountType ?? null,
              isTaxable: charge.isTaxable ?? null,
              isFromCommonRules: charge.isFromCommonRules ?? false,
              customerVisibility: charge.customerVisibility ?? null,
              price: this.toCalcPrice(charge.price),
              groupBucket: {
                id: charge.groupBucket.id,
                type: charge.groupBucket.type === ChargeAttachType.Equipment ? 'EQUIPMENT' : 'INVOICE',
              },
            }
          : null,
      };
    });
  }

  private toCalcPrice = (price: BasePrice): QuoteCalcPriceInput => ({
    total: price.total ?? 0,
    markup: price.markup ?? 0,
    netPrice: price.netPrice ?? 0,
    discount: price.discount ?? 0,
    salesTax: price.salesTax ?? 0,
    markupType: price.markupType,
    retailPrice: price.retailPrice ?? 0,
    discountType: price.discountType,
    salesTaxType: price.salesTaxType,
    wholesalePrice: price.wholesalePrice ?? 0,
  });
}

export const quoteCalcMapper = new QuoteCalcMapper();
